import ddt from '@wix/da-ddt';

const logger = ddt.createLogger('daeditorstandalone');
export default logger;
